export enum ContractType {
    Day = 1,
    Evening = 2,
    Night = 3,
    Rotate = 4
}

export enum ContractStatus {
    PRE = 'Pre-Start',
    PER_DIEM = 'Per Diem Pre-Start'
}
